import * as React from "react";

import { Text, TextInput, TouchableOpacity, View } from "react-native";

export function ManuelStockRow({
  stock,
  onUpdate,
  onDelete,
}: {
  stock: { symbol?: string; amount?: number };
  onUpdate: (stock: { symbol?: string; amount?: number }) => void;
  onDelete: () => void;
}) {
  return (
    <View style={{ flexDirection: "row", flex: 1 }}>
      <View>
        <Text
          style={{
            color: "white",
            marginVertical: 8,
          }}
        >
          Stock Name
        </Text>
        <TextInput
          style={{
            borderColor: "white",
            borderWidth: 1,
            padding: 8,
            borderRadius: 8,
            color: "white",
          }}
          defaultValue={stock.symbol}
          onChangeText={(text) => onUpdate({ ...stock, symbol: text })}
        />
      </View>
      <View style={{ marginHorizontal: 20 }}>
        <Text
          style={{
            color: "white",
            marginVertical: 8,
          }}
        >
          Amount
        </Text>
        <TextInput
          style={{
            borderColor: "white",
            borderWidth: 1,
            padding: 8,
            borderRadius: 8,
            color: "white",
          }}
          keyboardType="numeric"
          defaultValue={stock.amount + ""}
          onChangeText={(text) =>
            onUpdate({ ...stock, amount: parseFloat(text) })
          }
        />
      </View>
      <TouchableOpacity
        onPress={onDelete}
        style={[
          {
            padding: 4,
            marginVertical: 6,
            marginHorizontal: 12,
            borderRadius: 8,
            flexDirection: "row",
            alignSelf: "flex-end",
          },
        ]}
      >
        <Text
          style={[
            {
              color: "#ff0000",
              fontWeight: "500",
            },
          ]}
        >
          Delete
        </Text>
      </TouchableOpacity>
    </View>
  );
}
